module.exports = __webpack_public_path__ + "img/schema_tailles.b8c33d40.svg";